import notAuth from "@/middleware/notAuth";
import fetchUserData from "@/middleware/fetchUserData";
import auth from "@/middleware/auth";
import isSmsNotVerified from "@/middleware/isSmsNotVerified";
import isSmsVerified from "@/middleware/isSmsVerified";
import persistWebview from "@/middleware/persistWebview";

export default {
  path: "/",
  meta: {
    middlewares: [fetchUserData, notAuth, persistWebview],
  },
  component: () =>
    import(/* webpackChunkName: "layout" */ "@/layouts/User.vue"),
  children: [
    {
      path: "register",
      name: "RegisterPatient",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/Auth/Patient/Register.vue"
        ),
    },
    {
      path: "register-success",
      name: "RegisterSuccess",
      meta: {
        middlewares: [fetchUserData, auth, isSmsVerified],
      },
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/Auth/Patient/RegisterSuccess.vue"
        ),
    },
    {
      path: "code",
      name: "AuthCodePatient",
      meta: {
        middlewares: [fetchUserData, auth, isSmsNotVerified],
      },
      component: () =>
        import(/* webpackChunkName: "code" */ "@/views/Auth/Patient/Code.vue"),
    },
    {
      path: "login",
      name: "LoginPatient",
      component: () =>
        import(
          /* webpackChunkName: "login" */ "@/views/Auth/Patient/Login.vue"
        ),
    },
    {
      path: "password/email",
      name: "PasswordEmail",
      component: () =>
        import(
          /* webpackChunkName: "password-email" */ "@/views/Auth/Password/Email.vue"
        ),
    },
    {
      path: "password/reset/:code",
      name: "PasswordReset",
      component: () =>
        import(
          /* webpackChunkName: "password-reset" */ "@/views/Auth/Password/Reset.vue"
        ),
    },
    {
      path: "complete-data",
      name: "AuthPatientCompletionOfData",
      meta: {
        middlewares: [fetchUserData, auth, isSmsVerified],
      },
      component: () =>
        import(
          /* webpackChunkName: "complete-data" */ "@/views/Auth/Patient/CompletionOfData.vue"
        ),
    },
  ],
};
